module.exports = __webpack_public_path__ + "static/media/undercitybg21.f4201503.jpg";